import { NIUM_FOREX_CROSS_SELL_TEXT } from '../../../screens/nium-forex/forex-pages/cross-selling/utils';
import { NIUM_FOREX_CROSS_SELL_PROPOSITION } from '../../../screens/nium-forex/forex-pages/cross-selling/utils/constants';
import { HUNDRED_THOUSAND } from '../../../utils/constants';
import {
  CLEAR_STORE,
  CHANGE_CURRENT_SCREEN,
  STORE_NIUM_FOREX_USER,
  STORE_TRANSACTION_DETAILS,
  STORE_TEMP_TRANSACTION_ID,
  STORE_TRANSACTION_ID,
  STORE_SELECTED_BENE_ID,
  STORE_IS_PAN_VERIFIED,
  STORE_IS_PAN_NAME_VERIFIED,
  STORE_RE_VERIFY_AADHAR_FLAG,
  STORE_CAF_DOCUMENT_CHANGED_FLAG,
  STORE_NIUM_FOREX_USER_DETAILS,
  STORE_NF_CROSS_SELL_INFORMATION,
  STORE_IS_REFERRED
} from '../../action-contants';

const INITIAL_STATE = {
  isNiumForexUser: false,
  currentScreen: null,
  transactionDetails: {
    sourceAmount: HUNDRED_THOUSAND,
    sourceCurrency: 'INR',
    destinationCurrency: 'USD',
    destinationAmount: 0,
    tempTransactionId: null,
    transactionId: null,
    transactionNumber: null,
    sourceOfFunds: null,
    reasonForTransfer: null,
    remittanceType: null,
    selectedReasonForTransferCode: null,
    remittanceTypeCode: null,
    instaremFxRate: 0,
    netSourceAmount: 0,
    transactionFeeAmount: 0,
    taxAmount1: 0,
    taxAmount2: 0,
    taxAmount3: 0,
    netTaxAmount: 0,
    paymentMethodFeeAmount: 0,
    netOfFeeAmount: 0,
    payoutMethodFeeAmount: 0,
    couponCode: null,
    couponAmount: 0,
    isCouponApplied: false,
    fxRate: 0,
    taxType: null,
    taxType2: null,
    taxType3: null,
    marginAmount: 0,
    marginPercent: 0,
    transactionFeePercent: 0,
    paymentMethodFeePercent: 0,
    additionalInfo: null,
    beneDetails: {
      name: '',
      country: '',
      bankName: '',
      accountNumber: '',
      swiftCode: '',
      senderName: '',
      senderBankName: ''
    },
    remitterDetails: {
      remitterName: '',
      remitterBankName: ''
    }
  },
  isPanVerified: false,
  isPanNameVerified: false,
  reVerifyAadhar: false,
  selectedBeneId: null,
  cafDocumentFlag: false,
  userDetails: {},
  niumForexCrossSelling: {
    labels: NIUM_FOREX_CROSS_SELL_TEXT,
    explore: NIUM_FOREX_CROSS_SELL_PROPOSITION,
    currentExploreTab: 'prepaid_forex_card',
    selectedProducts: [],
    components: {
      nf_cross_sell_discovery_banner: NIUM_FOREX_CROSS_SELL_TEXT.nf_cross_sell_discovery_banner,
      nf_cross_sell_success_view: NIUM_FOREX_CROSS_SELL_TEXT.nf_cross_sell_success_view
    }
  },
  isReferral: false
};

export default function userFlowReducer(
  state = INITIAL_STATE,
  action: { type: string; data: any }
): any {
  switch (action.type) {
    case CLEAR_STORE: {
      return INITIAL_STATE;
    }

    case STORE_NIUM_FOREX_USER: {
      return {
        ...state,
        isNiumForexUser: action.data
      };
    }

    case CHANGE_CURRENT_SCREEN: {
      return {
        ...state,
        currentScreen: action.data
      };
    }

    case STORE_TRANSACTION_DETAILS: {
      return {
        ...state,
        transactionDetails: {
          ...state.transactionDetails,
          ...action.data
        }
      };
    }

    case STORE_TEMP_TRANSACTION_ID: {
      return {
        ...state,
        transactionDetails: {
          ...state.transactionDetails,
          tempTransactionId: action.data
        }
      };
    }

    case STORE_TRANSACTION_ID: {
      return {
        ...state,
        transactionDetails: {
          ...state.transactionDetails,
          transactionId: action.data
        }
      };
    }

    case STORE_SELECTED_BENE_ID: {
      return {
        ...state,
        selectedBeneId: action.data
      };
    }

    case STORE_IS_PAN_VERIFIED: {
      return {
        ...state,
        isPanVerified: action.data
      };
    }

    case STORE_IS_PAN_NAME_VERIFIED: {
      return {
        ...state,
        isPanNameVerified: action.data
      };
    }

    case STORE_RE_VERIFY_AADHAR_FLAG: {
      return {
        ...state,
        reVerifyAadhar: action.data
      };
    }

    case STORE_CAF_DOCUMENT_CHANGED_FLAG: {
      return {
        ...state,
        cafDocumentFlag: action.data
      };
    }

    case STORE_NIUM_FOREX_USER_DETAILS: {
      return {
        ...state,
        userDetails: action.data
      };
    }

    case STORE_NF_CROSS_SELL_INFORMATION: {
      return {
        ...state,
        niumForexCrossSelling: setCrossSellInformation(state.niumForexCrossSelling, action.data)
      };
    }
    case STORE_IS_REFERRED: {
      return {
        ...state,
        isReferral: action.data
      };
    }

    default:
      return state;
  }
}

const setCrossSellInformation = (state: { [key: string]: any }, data: { [key: string]: any }) => {
  const result = { ...state };
  for (const [key, value] of Object.entries(data)) {
    result[key] = value;
  }
  return result;
};
